export default __webpack_public_path__ + "static/media/bank-routing-number.72717a69.jpg";